// IDI contact options actions
import _get from 'lodash/get';
import axios from 'axios';
import Page from '../../lib/page';
import * as AsyncHelper from '../../lib/asyncMessageHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import * as types from '../constants/ActionTypes';
import { updateLexaMessage } from './action-lexa-message';
import { elmoExperimentResourceNames, elmoTreatmentNames, isPartOfElmoExpTreatment } from '../../lib/experiments-helper';
import { getElmoExperiments } from '../../home/actions/action-app';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const emailByPassPage = 'emailByPassPage';

function requestIDIContactOptions() {
  return {
    type: types.REQUEST_IDI_CONTACT_OPTIONS,
  };
}

function receivedIDIContactOptionsError() {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR,
  };
}

// Passing IDI channels(contact options) to redux state
function receivedIDIContactOptions(payload) {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE,
    payload,
  };
}

function receivedResponseFromRisk(riskOptions) {
  return {
    type: types.RECEIVED_RESPONSE_FROM_RISK,
    payload: riskOptions,
  };
}

// Send IDI Post request to IDI server
function userSelectionPostRequest(kanaCode, topicName) {
  return axios.post('/smarthelp/update-user-selection', {
    _csrf: Page.getCSRFtoken(),
    topicId: kanaCode,
    topicName,
  });
}

// Update User Selection for both Login and Logout users
function updateUserSelection(id) {
  return (dispatch, getState) => {
    const { topicName } = _get(getState(), 'selectResult.topicTreeSelectResult');
    const kanaCode = id === emailByPassPage ? _get(getState(), 'emailNoIntent.kanaCode') : _get(getState(), 'emailForm.kanaCode');
    trackLink({ id, link: `smarthelp-topic-update-idi|${kanaCode}|` });

    const postRequest = userSelectionPostRequest(kanaCode, topicName);

    // Using remote config to control IDI contact options display logic
    if (Page.getIsIDIContactOptions()) {
      postRequest.then((response) => {
        dispatch(requestIDIContactOptions());
        dispatch(receivedResponseFromRisk((response.data || {}).channel_availability_decisions || {}));
        let IDIChannels = AsyncHelper.IDIChannelFilter(_get(response, 'data.channels'));
        const availability = _get(response, 'data.channel_availability_decisions', []);

        // Checking the Message option whether exists in the IDI response or not
        if (AsyncHelper.isAsyncChatEnable({ channels: IDIChannels, availability })) {
          const waitTime = AsyncHelper.getWaitTime(availability); // get Message_Us estimate wait time
          dispatch(updateLexaMessage({ available: true, waitTime }));
        } else if (Array.isArray(IDIChannels)) {
          // If async messaage is not available, then filter out async option
          IDIChannels = IDIChannels.filter(channel => channel.type !== 'message');
          dispatch(updateLexaMessage({ available: false }));
        }

        if (Array.isArray(IDIChannels) && IDIChannels.length > 0) {
          if (Page.hasChatOptions(IDIChannels)) {
            trackPage({ id: 'contactUsPage', link: 'chat-option-lexa' });
          }

          dispatch(getElmoExperiments(elmoExperimentResourceNames.finalIntentContactOps)).then(() => {
            const elmTrt = _get(getState(), 'app.elmoTreatments');
            if (isPartOfElmoExpTreatment(elmTrt, elmoTreatmentNames.finalIntentContactOpsTrtm)) {
              trackPage({ id: 'contactUsPage', link: 'recommendedContactFooter' });
            }
            dispatch(receivedIDIContactOptions({ channels: IDIChannels, availability }));
          }).catch(() => {
            dispatch(receivedIDIContactOptions({ channels: IDIChannels, availability }));
          });
        } else {
          dispatch(receivedIDIContactOptionsError());
        }
      });
      postRequest.catch(() => dispatch(receivedIDIContactOptionsError()));
    }
    return postRequest;
  };
}

module.exports = {
  updateUserSelection,
};
